/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_GrantInputs */

const cs_billing_grant = /** @type {(inputs: Billing_GrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat firemní kredity`)
};

const en_billing_grant = /** @type {(inputs: Billing_GrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grant org credits`)
};

/**
* | output |
* | --- |
* | "Grant org credits" |
*
* @param {Billing_GrantInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_grant = /** @type {((inputs?: Billing_GrantInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_GrantInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_grant(inputs)
	return cs_billing_grant(inputs)
});